import { render, staticRenderFns } from "./invoice_detail.vue?vue&type=template&id=2a41edb8&scoped=true&"
import script from "./invoice_detail.vue?vue&type=script&lang=js&"
export * from "./invoice_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41edb8",
  null
  
)

export default component.exports